import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Japanese%20temple%20gate%20with%20warm%20sunset%20light%2C%20cherry%20blossom%20petals%20floating%20in%20air%2C%20traditional%20Japanese%20architecture%20silhouette%2C%20mount%20Fuji%20in%20distant%20background%2C%20atmospheric%20warm%20golden%20tones%2C%20soft%20dreamy%20aesthetic%2C%20cinematic%20wide%20composition%2C%20minimalist%20elegant%20style&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="亚洲一级日本精选内容导航平台"
          title="亚洲一级日本精选内容导航平台 - 顶级日本文化资源导航"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-star-fill text-xs text-accent-400"></i>
          </div>
          <span className="text-xs md:text-sm text-background-50/90 font-medium whitespace-nowrap">亚洲顶级日本内容精选平台</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
          亚洲一级日本
          <br />
          <span className="text-accent-400">精选内容导航</span>
        </h1>

        <p className="text-sm md:text-base text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          汇聚亚洲精华，精选日本一级内容。专业分级导航、精准内容推荐，为您开启最优质的日本文化、娱乐、生活方式探索之旅。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/japanese-culture"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            开始探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm text-background-50 rounded-lg font-medium text-sm border border-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}